import { DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  SHORT_MONTH_DAY_12HOUR_FORMAT,
  formatDate,
  getTimeAgo,
} from 'shared/dates';
import { GeoEventMetadataText } from 'features/geoEvents/components/GeoEventMetadataRows';
import { PowerOutagePoi } from './PoiDialog.types';
import { EMPTY_DATA_VALUE } from '../../../../../constants';

export const PowerOutageDialogContent = (
  props: PowerOutagePoi,
): JSX.Element => {
  const { t } = useTranslation();

  const {
    dateRecorded,
    estimatedRestorationTime,
    utilityName,
    customersAffected,
    cause,
  } = props;

  const dateRecordedRelative = dateRecorded && getTimeAgo(dateRecorded);
  const dateRecordedFormatted =
    dateRecorded && formatDate(dateRecorded, SHORT_MONTH_DAY_12HOUR_FORMAT);

  const dateResolvedFormatted = estimatedRestorationTime
    ? formatDate(estimatedRestorationTime, SHORT_MONTH_DAY_12HOUR_FORMAT)
    : EMPTY_DATA_VALUE;

  return (
    <>
      <DialogTitle
        sx={{
          padding: 2,
          paddingTop: 1,
          paddingBottom: 1,
        }}
      >
        <Typography component="span" variant="body1">
          <b>{t('map.poi.powerOutage.powerOutage')}</b>
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 2 }}>
        <GeoEventMetadataText truncate={false} sx={{ display: 'block' }}>
          <b>{utilityName}</b>
          {' ･ '}
          <b>{dateRecordedRelative}</b>
          {dateRecorded && ` ･ ${dateRecordedFormatted}`}
        </GeoEventMetadataText>
        <Grid container rowGap={0.5} sx={{ marginTop: 1 }}>
          <Grid size={{ xs: 6 }}>
            <Typography
              variant="h4"
              sx={(theme) => ({ fontSize: theme.typography.body2.fontSize })}
            >
              {t('map.poi.powerOutage.estimatedRestoration')}
            </Typography>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography variant="body2">{dateResolvedFormatted}</Typography>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography
              variant="h4"
              sx={(theme) => ({ fontSize: theme.typography.body2.fontSize })}
            >
              {t('map.poi.powerOutage.customersAffected')}
            </Typography>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography variant="body2">{customersAffected}</Typography>
          </Grid>
          {Boolean(cause) && (
            <>
              <Grid size={{ xs: 6 }}>
                <Typography
                  variant="h4"
                  sx={(theme) => ({
                    fontSize: theme.typography.body2.fontSize,
                  })}
                >
                  {t('map.poi.powerOutage.cause')}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography variant="body2">{cause}</Typography>
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
    </>
  );
};
